/*
    generate by magix-combine@3.6.4: https://github.com/thx/magix-combine
    author: kooboy_li@163.com
    loader: webpack
 */

Magix.applyStyle("xf2g","@font-face{font-family:uxiconfont;src:url(//assets.alicdn.com/apps/e/brix/fonts/uxiconfont.eot);src:url(//assets.alicdn.com/apps/e/brix/fonts/uxiconfont.eot#iefix) format(\"embedded-opentype\"),url(//assets.alicdn.com/apps/e/brix/fonts/uxiconfont.woff) format(\"woff\"),url(//assets.alicdn.com/apps/e/brix/fonts/uxiconfont.ttf) format(\"truetype\"),url(//assets.alicdn.com/apps/e/brix/fonts/uxiconfont.svg#uxiconfont) format(\"svg\")}.iconfont{font-family:uxiconfont;font-size:16px;font-style:normal}.backtop{position:fixed;bottom:50px;overflow:hidden;right:0;z-index:200;text-align:center;width:44px;height:50px;filter:alpha(opacity=70);opacity:.7}.backtop .trigger{display:block;overflow:hidden;border:1px solid #c6c6c6;margin-top:-2px;background:#bbbdc1}.backtop .trigger:hover{background:#aeaeae}.backtop .trigger span{display:block;width:40px;height:48px;line-height:48px;color:#fff;font-size:16px;border:1px solid #cbcbcb}.backtop .totop-btn{display:none}");

module.exports = Magix.View.extend({
    tmpl: {"html":"<div class=\"backtop\"><a href=\"#\" class=\"trigger totop-btn\" title=\"回到顶部\"><span class=\"iconfont\">&#404;</span></a></div>","subs":[]},
    ctor: function ctor(opt) {
        this.opt = $.extend(true, opt, {
            S: KISSY,
            Node: null
        });
    },
    initBackTop: function initBackTop() {
        var S = this.opt.S,
            Node = this.opt.Node;

        function BackTop() {
            var win = S.one(window);
            this.holder = S.one('.backtop');
            this.topBtn = S.one('.totop-btn', this.holder);

            this._detect();
            this.events();
        }
        BackTop.prototype._detect = function () {
            var self = this;
            var win = S.one(window);
            var top = win.scrollTop();
            if (top > 0) {
                self.topBtn.css('display', 'block');
                if (S.UA.ie && S.UA.ie < 7) {
                    var t = S.DOM.viewportHeight() + top - 45 - 125;
                    self.holder.css('top', t);
                }
            } else {
                self.topBtn.hide();
            }
        };
        BackTop.prototype.events = function () {
            var win = S.one(window);
            var self = this;
            win.on('scroll', function () {
                self._detect();
            });
            self.topBtn.on('click', function (e) {
                e.preventDefault();
                var trigger = Node(e.currentTarget);
                S.one(window).animate({
                    scrollTop: 0
                }, {
                    duration: 0.5,
                    easing: 'easeOut'
                });
            });
        };
        new BackTop();
    },
    render: function render() {
        var self = this;
        KISSY.use("node", function (S, Node) {
            self.opt.Node = Node;
            self.updater.set({}).digest();
            self.initBackTop();
        });
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/views/backtop/index.js
// module id = 2
// module chunks = 1 2